export default __webpack_public_path__ + "static/RunLeft3-52b51d3b72fb0b0578a4012e6483a79c.mp3";